import React, { useState, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { jsPDF } from "jspdf";
import Draggable from "react-draggable";
import { CloseOutlined, PrinterOutlined } from "@ant-design/icons";
import { Modal, Button, Typography, Table } from "antd";
import { useIntl } from "react-intl";
import Employee from "../../../components/tables/Employee";
import Date from "../../../components/tables/Date";
import moment from "moment";
import {
  getFullName,
  getOrderChangeLogsPdf,
} from "../../../components/util/helpers";

const { Title, Text } = Typography;
const ChangeLogModal = (props) => {
  const { orderChangeLogs, onHide, visible, record } = props;
  const intl = useIntl();
  const [disabled, setDisabled] = useState(true);

  const onCancel = () => {
    onHide();
  };

  const printLogs = () => {
    const patientName = getFullName(
      record["patient.surename"],
      record["patient.first_name"]
    );
    const localId = record["patient.local_id_number"];
    const maxHours =
      record &&
      record.recurrent_work_events &&
      record.recurrent_work_events[0] &&
      record.recurrent_work_events[0].order.max_hours;
    const clientName = record && record["client.name"];
    const doc = getOrderChangeLogsPdf(
      orderChangeLogs,
      intl,
      clientName,
      patientName,
      localId,
      maxHours
    );
    window.open(doc.output("bloburl"), "_blank");
  };

  const expandedRowRender = (record) => {
    const columns = [
      {
        title: intl.formatMessage({
          id: "app.plans.employee",
        }),
        dataIndex: "employee",
        render(text, record) {
          return record && record.employee ? (
            <Employee record={record.employee} />
          ) : null;
        },
        width: "220px",
      },
      {
        title: intl.formatMessage({
          id: "app.plans.weekday",
        }),
        dataIndex: "weekday",
        render(text) {
          return <Text>{moment.weekdays(text)}</Text>;
        },
        // width: "70px",
      },
      {
        title: intl.formatMessage({
          id: "app.plans.start_time",
        }),
        dataIndex: "start_time_minutes",
        render(text) {
          return (
            text && (
              <Date
                text={moment().startOf("day").set("minute", text)}
                format={"HH:mm"}
              />
            )
          );
        },
        // width: "70px",
      },
      {
        title: intl.formatMessage({
          id: "app.plans.end_time",
        }),
        dataIndex: "end_time",
        render(text, record) {
          return (
            record.duration_minutes && (
              <Date
                text={moment()
                  .startOf("day")
                  .set(
                    "minute",
                    record.duration_minutes + record.start_time_minutes
                  )}
                format={"HH:mm"}
              />
            )
          );
        },
        // width: "70px",
      },
      {
        title: intl.formatMessage({
          id: "app.plans.duration",
        }),
        dataIndex: "duration_minutes",
        render(text) {
          return text && <Text>{Math.round((text / 60) * 100) / 100}</Text>;
        },
        // width: "70px",
      },
    ];

    return (
      <Table
        className="table-nested"
        columns={columns}
        dataSource={record.events
          .sort((a, b) => a.start_time_minutes - b.start_time_minutes)
          .sort((a, b) => a.weekday - b.weekday)}
        pagination={false}
        size="small"
        bordered={true}
        style={{ width: "650px" }}
      />
    );
  };

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.plans.created_by",
      }),
      dataIndex: "created_by",
      render(text, record) {
        return text && text.name && <Text>{text.name}</Text>;
      },
      width: "220px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.created_at",
      }),
      dataIndex: "created_at",
      render(text) {
        return text && <Text>{moment(text).format("L")}</Text>;
      },
      width: "140px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.created_at_hour",
      }),
      dataIndex: "created_at",
      render(text) {
        return text && <Text>{moment(text).format("HH:mm")}</Text>;
      },
      width: "140px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.effective_from_change",
      }),
      dataIndex: "effective_from",
      render(text) {
        return text && <Text>{moment(text).format("L")}</Text>;
      },
      width: "140px",
    },
  ];

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      open={visible}
      destroyOnClose={true}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
    >
      <div>
        <div
          style={{
            width: "100%",
            cursor: "move",
            height: "50px",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          className="header"
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            padding: "40px 80px 40px 80px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <div>
              <Title
                style={{
                  fontSize: "30px",
                  fontWeight: 500,
                  lineHeight: 1.27,
                  color: "rgba(0, 0, 0, 0.85)",
                  margin: "0",
                }}
              >
                {<FormattedMessage id="app.plans.order_plan_logs_title" />}
              </Title>
              <Title
                level={5}
                style={{
                  margin: "0 0 40px 0",
                }}
              >
                {record && record["client.name"]}
              </Title>
            </div>

            <Button icon={<PrinterOutlined />} onClick={() => printLogs()}>
              {" "}
              {<FormattedMessage id="app.actions.print" />}
            </Button>
          </div>

          <div>
            <Table
              bordered
              dataSource={orderChangeLogs}
              rowKey={(record) => record.id}
              columns={columns}
              pagination={false}
              scroll={{
                y: window.innerHeight - 400,
              }}
              expandable={{
                expandedRowRender,
                defaultExpandedRowKeys: ["0"],
              }}
              style={{ width: "750px" }}
            />
          </div>
          <div />
        </div>
      </div>
    </Modal>
  );
};

export default ChangeLogModal;
